import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const name = 'getOperationsEmailRule'

export default () => (asyncAction(
  name,
  EmailRulesService.getOperationsEmailRule
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/email-rules/getOperationsEmailRule.js